export default "__VITE_ASSET__DdVd4xmc__$_?inline__"